export { P100CheckoutPage as default } from './components/P100CheckoutPage';
